import { render, staticRenderFns } from "./seniority-remuneration.view.vue?vue&type=template&id=35df92dc&scoped=true&"
import script from "./seniority-remuneration.view.vue?vue&type=script&lang=ts&"
export * from "./seniority-remuneration.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df92dc",
  null
  
)

export default component.exports